import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomFileValidator {
  
  // Validador para tamaño minimo de archivo
  static minContentSize(minSize: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const fileWrapper = control.value;
        // Verifica si el objeto tiene la propiedad _files y extrae el archivo (Esto es por la forma en la
        // que se pasa el archivo al validador desde el componente)
        const file = fileWrapper?._files?.[0];
        if (file && file.size < minSize) {
        return { minContentSize: { requiredSize: minSize, actualSize: file.size } };
        }
        return null;
    };
  }

}